import React, { useEffect, useState, useCallback, useRef } from "react";
import { Dropdown, Modal, Button, Tabs, Tab, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner";
import {
  addFile,
  createNewAdmin,
  deleteAdmin,

  getUrl,
  updateAdminInfo,
  updateAdminStatus,
  verifyUser,
 
} from "../../services/Admin/adminServices";

import Pagination from "../components/Pagination";
import { useFetcher, useNavigate, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { deletedUsers, getUserList, getWaitList } from "../../services/UserServices/UserService";

const ReadMoreText = ({ text, maxLength = 30, maxWidth = "220px" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return "_";

  const textStr = typeof text === "string" ? text : String(text);
  const formattedText = textStr.charAt(0).toUpperCase() + textStr.slice(1);

  if (formattedText.length <= maxLength) {
    return <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{formattedText}</span>;
  }

  return (
    <div style={{ maxWidth: isExpanded ? "350px" : maxWidth, wordBreak: "break-word", whiteSpace: "normal" }}>
      {isExpanded ? formattedText : `${formattedText.slice(0, maxLength)}...`}
      <button
        type="button"
        className="btn btn-link p-0 text-primary fw-semibold ms-1"
        style={{ fontSize: "12px", textDecoration: "none", boxShadow: "none", verticalAlign: "baseline" }}
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
};

const DeleteUsers = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
   const [deleteReason, setDeleteReason] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0
  );
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState("User");
  const [type, setType] = useState("Verified");
 
  const [confirmState, setConfirmState] = useState({
    show: false,
    action: null,
    id: null,
    status: null,
    message: "",
  });
 const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const fetchAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const response = await deletedUsers(
        currentPage,
        itemsPerPage,
        
      );
      setAdmins(response?.data?.data?.users || []);
       
      setTotalItems(response?.data?.data?.total || 0);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, [
    currentPage,
    itemsPerPage,
   
  ]);
 useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);
 
  
  useEffect(() => {
    if (currentPage !== undefined) {
      navigate(".", {
        replace: true,
        state: { ...location.state, currentPage },
      });
    }
  }, [currentPage]);

  const activeTabMount = useRef(true);
  useEffect(() => {
    if (activeTabMount.current) {
      activeTabMount.current = false;
      return;
    }
    setCurrentPage(0);
  }, [activeTab]);
 
  const totalPages = Math.ceil(totalItems / itemsPerPage);
 
const handleExportCSV = () => {
  if (!admins || admins.length === 0) {
    toast.error("No data available to export");
    return;
  }

  const csvData = admins.map((admin, index) => ({
    "Sr No": currentPage * itemsPerPage + index + 1,
    Name: admin.name || "",
    Email: admin.email || "",
    Phone: admin.phoneNumber
      ? `${admin.countryCode || ""} ${admin.phoneNumber}`
      : "",
    Address: admin.address || "",
    Status:
      admin.adminApprove === "Verified"
        ? admin.isBlocked
          ? "Disabled"
          : "Enabled"
        : "",
    Verification: admin.adminApprove || "",
    "Created At": admin.createdAt
      ? `${new Date(admin.createdAt).toLocaleDateString("en-CA", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })} ${new Date(admin.createdAt).toLocaleTimeString("en-CA", {
          hour: "2-digit",
          minute: "2-digit",
        })}`
      : "",
  }));

  const headers = Object.keys(csvData[0]);

  const csvContent = [
    headers.join(","),
    ...csvData.map((row) =>
      headers
        .map((header) =>
          `"${String(row[header] ?? "").replace(/"/g, '""')}"`
        )
        .join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.setAttribute(
    "download",
    `users_${new Date().toISOString().split("T")[0]}.csv`
  );

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);

  toast.success("CSV exported successfully");
};
 


  return (
    <div className="container mt-4">
   <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 style={{ color: "#E5484D" }}>Deleted Accounts</h1>
 
      </div>


 

  
          {loading ? (
            <Spinner />
          ) : (
            <div className="table-responsive">
              <table className="table table-striped align-middle shadow-sm">
                <thead className="table-light">
                  <tr>
                    <th>Sr No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone Number</th> 
                    <th style={{ minWidth: "180px" }}>Address</th>
                    <th>Deleted At</th>
                    <th style={{ minWidth: "180px" }}>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {admins?.length > 0 ? (
                    admins.map((admin, index) => (
                      <tr key={admin._id || index}>
                        <td>{currentPage * itemsPerPage + index + 1}</td>
                        <td>
                          {admin?.user?.name
                            ? `${admin?.user?.name
                                .charAt(0)
                                .toUpperCase()}${admin?.user.name?.slice(1)}`
                            : "_"}
                        </td>
                        <td>{admin?.user?.email ? admin?.user?.email : "_"}</td>
                        <td>
                          {admin?.user?.phoneNumber
                            ? `${admin.user.countryCode || ""} ${admin.user.phoneNumber}`
                            : "_"}
                        </td>
                        <td>
                          <ReadMoreText text={admin?.user?.address} maxLength={30} maxWidth="200px" />
                        </td>
                        <td>
                          {new Date(admin?.createdAt).toLocaleDateString(
                            "en-CA",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )}
                          {", "}
                          {new Date(admin?.createdAt).toLocaleTimeString(
                            "en-CA",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          )}
                        </td>
                        <td>
                          <ReadMoreText text={admin?.reason} maxLength={30} maxWidth="220px" />
                        </td>
 
                        {/* <td style={{ textAlign: "center" }}>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id={`dropdown-basic-${index}`}
                              style={{ padding: "4px 8px" }}
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
  
     </Dropdown.Menu>
                          </Dropdown>
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
      

      <div className="card-footer clearfix mt-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
          <div
            className="dataTables_info fw-bold mb-3 mb-md-0"
            style={{ color: "#E5484D" }}
          >Total Accounts : {totalItems}</div>
          <div className="d-flex align-items-center">
            {totalPages > 0 && (
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            )}
          </div>
        </div>
      </div>

      

     
   
    </div>
  );
};

export default DeleteUsers;
